export const common = {
  nav: {
    home: 'Inicio',
    about: 'Acerca de',
    gimcheon: '2026 Gimcheon',
    announcement: 'Anuncio',
    contact: 'Contacto',
    login: 'Iniciar sesión',
    signUp: 'Registrarse',
    privacy: 'Política de privacidad'
  },
  hero: {
    title: 'Copa Mundial de Gimcheon',
    subtitle: 'CAMPEONATOS MUNDIALES DE GIMCHEON',
    description: '',
    cta: 'Regístrate ahora',
    registerNow: 'Regístrate ahora',
    learnMore: 'Más información',
    guidelinesTitle: 'Directrices de la competencia',
    guidelinesEnglish: 'Directrices en inglés',
    guidelinesKorean: 'Directrices en coreano',
    travelAgency: 'Agencia Oficial de Viajes y Turismo',
    kombatGuidelines: 'Directrices de la Liga de Taekwondo Kombat'
  },
  about: {
    title: 'Sobre Nosotros',
    subtitle: '',
    description: 'Con décadas de dedicación al Taekwondo, nuestro Campeón Mundial ha alcanzado los más altos honores en competencias internacionales. Desde medallas olímpicas hasta títulos de Campeonatos Mundiales, el viaje representa un compromiso inquebrantable con la excelencia en artes marciales.',
    experience: 'Años de Experiencia',
    students: 'Estudiantes Entrenados',
    medals: 'Medallas Internacionales',
    stats: {
      years: 'Años de Experiencia',
      students: 'Estudiantes Entrenados',
      medals: 'Medallas Internacionales'
    },
    philosophy: 'Filosofía de Entrenamiento',
    philosophyText: 'La verdadera maestría proviene del equilibrio perfecto entre técnica física, disciplina mental y crecimiento espiritual. Cada estudiante tiene el potencial de convertirse en un campeón a su manera.'
  },
  gimcheon: {
    badge: 'PRÓXIMO EVENTO',
    title: 'Campeonato Mundial de Taekwondo Gimcheon 2026',
    mainTitle: 'Un Campeonato Abierto Global para Todos los Atletas de Taekwondo',
    description1: 'El Campeonato Mundial de Taekwondo Gimcheon 2026 es un evento abierto internacional que da la bienvenida a atletas de todo el mundo. Este campeonato único reúne WT (Olímpico), ITF (Tradicional) y Kombat Taekwondo en un escenario global.',
    description2: 'Desde principiantes hasta atletas de élite, desde niños hasta maestros — todas las nacionalidades, edades y niveles de cinturón son bienvenidos.',
    description3: '',
    subtitle: 'El Campeonato Internacional Premier de Taekwondo',
    dateLabel: 'Fecha del Evento',
    date: '11-12 de julio de 2026',
    eventDate: '2026.07.11-12',
    dateText: 'Fecha',
    locationLabel: 'Ubicación',
    location: 'Complejo Deportivo de Gimcheon, Corea del Sur',
    venue: 'Gimnasio de Gimcheon',
    venueLocation: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, Corea del Sur',
    categoriesLabel: 'Categorías',
    categories: 'Todos los Grupos de Edad y Clases de Peso',
    deadline: 'Fecha límite de inscripción anticipada: 31 de marzo de 2026',
    registerButton: 'Regístrate Ahora',
    registerTitle: 'Registrarse para el Campeonato Mundial de Taekwondo',
    joinUs: 'Únase a nosotros',
    register: 'Registrarse',
    international: 'Participación Internacional',
    internationalDesc: 'Atletas de más de 50 países compitiendo al más alto nivel de excelencia en Taekwondo.',
    competition: 'Instalaciones de Clase Mundial',
    competitionDesc: 'Lugares de competencia con estándares olímpicos con equipos de última generación y jueces profesionales.',
    streaming: 'Cobertura en Vivo',
    streamingDesc: 'Transmisión en vivo profesional y cobertura de difusión que llega a millones de espectadores en todo el mundo.',
    cultural: 'Intercambio Cultural',
    culturalDesc: 'Talleres, seminarios y programas culturales que celebran el espíritu y la tradición de las artes marciales.',
    travelAgency: {
      title: 'Agencia de Viajes Asociada Oficial',
      description: 'El campeonato se opera en cooperación con una agencia de viajes asociada oficial para apoyar a los participantes y equipos internacionales.',
      servicesTitle: 'A través del enlace a continuación, puede encontrar:',
      service1: 'Paquetes de alojamiento para atletas',
      service2: 'Recogida en el aeropuerto y transporte local',
      service3: 'Tours culturales de Corea',
      service4: 'Servicios de viaje relacionados con campamentos de entrenamiento y competencias',
      cta: 'Haga que su participación en el campeonato sea más fácil y cómoda.'
    }
  },
  training: {
    title: 'Entrenamiento y Clases',
    subtitle: 'Programas para Todos los Niveles',
    beginners: 'Programa para Principiantes',
    beginnersDesc: 'Perfecto para aquellos nuevos en Taekwondo. Aprende técnicas fundamentales, formas básicas y disciplina esencial en un ambiente de apoyo.',
    intermediate: 'Entrenamiento Intermedio',
    intermediateDesc: 'Avanza tus habilidades con técnicas complejas, práctica de combate y preparación competitiva. Construye fuerza y confianza.',
    advanced: 'Avanzado y Competencia',
    advancedDesc: 'Entrenamiento de élite para competidores serios. Domina técnicas avanzadas, combate estratégico y rendimiento a nivel de campeonato.',
    private: 'Entrenamiento Privado',
    privateDesc: 'Sesiones individuales con el Campeón Mundial. Planes de entrenamiento personalizados adaptados a tus objetivos y habilidades específicas.',
    kids: 'Clases para Niños',
    kidsDesc: 'Clases divertidas y atractivas para niños de 5 a 12 años. Desarrolla disciplina, respeto, coordinación y confianza a través del Taekwondo.',
    adults: 'Clases para Adultos',
    adultsDesc: 'Entrenamiento integral para adultos de todos los niveles de condición física. Mejora la salud, aprende defensa personal y logra crecimiento personal.'
  },
  gallery: {
    title: 'Galería y Pósters',
    subtitle: 'Momentos de Gloria',
    viewAll: 'Ver Todas las Fotos'
  },
  contact: {
    title: 'Contáctenos',
    subtitle: 'Comienza tu Viaje Hoy',
    teamName: 'Nombre del Equipo',
    teamNamePlaceholder: 'Ingresa el nombre de tu equipo',
    country: 'País',
    countryPlaceholder: 'Selecciona tu país',
    contactPerson: 'Nombre de la Persona de Contacto',
    contactPersonPlaceholder: 'Ingresa el nombre de la persona de contacto',
    name: 'Tu Nombre',
    email: 'Correo Electrónico',
    emailPlaceholder: 'Ingresa tu correo electrónico',
    phone: 'Número de Teléfono',
    phoneNumber: 'Número de teléfono',
    contactMethod: 'Método de Contacto Preferido',
    contactValue: 'Valor de Contacto',
    phoneLabel: 'Número de Teléfono',
    whatsappLabel: 'Número de WhatsApp',
    telegramLabel: 'Usuario de Telegram',
    wechatLabel: 'ID de WeChat',
    phonePlaceholder: '+82 10-1234-5678',
    whatsappPlaceholder: '+82 10-1234-5678',
    telegramPlaceholder: '@usuario',
    wechatPlaceholder: 'ID de WeChat',
    message: 'Mensaje',
    messagePlaceholder: 'Cuéntanos sobre tu equipo y detalles de registro',
    messageLimit: 'Máximo 500 caracteres',
    submit: 'Enviar',
    submitting: 'Enviando...',
    successMessage: 'Gracias por tu información. Te contactaremos en 24 horas.',
    errorMessage: 'Error al enviar el registro. Por favor, inténtalo de nuevo.',
    send: 'Enviar Mensaje',
    info: 'Información de Contacto',
    address: 'Dirección',
    addressText: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, Corea del Sur',
    hours: 'Horarios de Entrenamiento',
    hoursText: 'Lunes - Viernes: 6:00 AM - 9:00 PM\nSábado: 8:00 AM - 6:00 PM\nDomingo: 9:00 AM - 3:00 PM',
    followUs: 'Síguenos'
  },
  footer: {
    tagline: 'Comité Mundial de Deportes (Asociación Incorporada)',
    quickLinks: 'Enlaces Rápidos',
    copyright: '© 2025 GCWC Taekwondo. Todos los derechos reservados.',
    poweredBy: 'Powered by Readdy'
  },
  popup: {
    badge: 'REGISTRAR COMPETENCIA',
    title: 'Campeonato Mundial Gimcheon 2026',
    dateLabel: 'Fecha',
    date: '11-12 de julio de 2026',
    locationLabel: 'Ubicación',
    location: 'Gimcheon Sports Complex, 1 Undongjang-gil, Gimcheon-si, Gyeongbuk, Corea del Sur',
    categoriesLabel: 'Categorías',
    categories: 'Todos los Grupos de Edad y Clases de Peso',
    highlightsTitle: 'Aspectos Destacados de la Competencia',
    highlight1: 'Atletas internacionales',
    highlight2: 'Instalaciones de competencia con estándares olímpicos',
    highlight3: 'Transmisión en vivo y cobertura profesional',
    highlight4: 'Programas de intercambio cultural y talleres',
    applyButton: 'Solicitar aquí',
    registerButton: 'Regístrate Ahora',
    registerHereButton: 'Registrarse aquí',
    closeButton: 'Cerrar',
    deadline: 'Fecha límite de inscripción anticipada: 31 de marzo de 2026'
  },
  competitionButton: {
    text: 'Registrar Competencia',
    shortText: 'Info'
  },
  login: {
    title: 'Bienvenido de Nuevo',
    subtitle: 'Inicia sesión en tu cuenta para continuar',
    email: 'Correo Electrónico',
    emailPlaceholder: 'Ingresa tu correo',
    password: 'Contraseña',
    passwordPlaceholder: 'Ingresa tu contraseña',
    rememberMe: 'Recuérdame',
    forgotPassword: '¿Olvidaste tu Contraseña?',
    loginButton: 'Iniciar Sesión',
    or: 'O',
    googleLogin: 'Continuar con Google',
    facebookLogin: 'Continuar con Facebook',
    noAccount: '¿No tienes una cuenta?',
    signUpLink: 'Registrarse',
    termsText: 'Al iniciar sesión, aceptas nuestros',
    termsLink: 'Términos y Condiciones'
  },
  signup: {
    title: 'Crear Cuenta',
    subtitle: 'Únete a nuestra comunidad de Taekwondo hoy',
    fullName: 'Nombre Completo',
    fullNamePlaceholder: 'Ingresa tu nombre completo',
    email: 'Correo Electrónico',
    emailPlaceholder: 'Ingresa tu correo',
    password: 'Contraseña',
    passwordPlaceholder: 'Crea una contraseña',
    confirmPassword: 'Confirmar Contraseña',
    confirmPasswordPlaceholder: 'Confirma tu contraseña',
    phone: 'Número de Teléfono',
    phonePlaceholder: 'Ingresa tu número de teléfono',
    dateOfBirth: 'Fecha de Nacimiento',
    beltLevel: 'Nivel de Cinturón Actual',
    selectBelt: 'Selecciona tu nivel de cinturón',
    whiteBelt: 'Cinturón Blanco',
    yellowBelt: 'Cinturón Amarillo',
    greenBelt: 'Cinturón Verde',
    blueBelt: 'Cinturón Azul',
    redBelt: 'Cinturón Rojo',
    blackBelt: 'Cinturón Negro',
    agreeText: 'Acepto los',
    termsLink: 'Términos y Condiciones',
    and: 'y',
    privacyLink: 'Política de Privacidad',
    signUpButton: 'Crear Cuenta',
    or: 'O',
    googleSignUp: 'Registrarse con Google',
    facebookSignUp: 'Registrarse con Facebook',
    haveAccount: '¿Ya tienes una cuenta?',
    loginLink: 'Iniciar Sesión',
    passwordMismatch: 'Las contraseñas no coinciden',
    agreeTermsRequired: 'Debes aceptar los términos y condiciones'
  },
  privacyPolicy: {
    title: 'Política de Privacidad',
    lastUpdated: 'Última Actualización',
    introduction: {
      title: 'Introducción',
      content: 'Bienvenido a GCWC (Gimcheon World Champions). Respetamos su privacidad y estamos comprometidos a proteger sus datos personales. Esta política de privacidad le informará sobre cómo cuidamos sus datos personales cuando visita nuestro sitio web y le informará sobre sus derechos de privacidad y cómo la ley lo protege.'
    },
    infoCollect: {
      title: 'Información que Recopilamos',
      content: 'Podemos recopilar, usar, almacenar y transferir diferentes tipos de datos personales sobre usted que hemos agrupado de la siguiente manera:',
      item1: 'Datos de Identidad: incluye nombre, apellido, nombre de usuario o identificador similar',
      item2: 'Datos de Contacto: incluye dirección de correo electrónico y números de teléfono',
      item3: 'Datos Técnicos: incluye dirección de protocolo de Internet (IP), tipo y versión del navegador, configuración de zona horaria y ubicación, sistema operativo y plataforma',
      item4: 'Datos de Uso: incluye información sobre cómo usa nuestro sitio web, productos y servicios'
    },
    howWeUse: {
      title: 'Cómo Usamos su Información',
      content: 'Solo usaremos sus datos personales cuando la ley nos lo permita. Comúnmente, usaremos sus datos personales en las siguientes circunstancias:',
      item1: 'Para registrarlo como nuevo estudiante o miembro',
      item2: 'Para procesar y gestionar su registro para competiciones',
      item3: 'Para gestionar nuestra relación con usted, incluida la notificación de cambios en nuestros servicios',
      item4: 'Para mejorar nuestro sitio web, productos/servicios, marketing o relaciones con los clientes'
    },
    adsense: {
      title: 'Google AdSense y Publicidad',
      content: 'Usamos Google AdSense para mostrar anuncios en nuestro sitio web. Google AdSense usa cookies para mostrar anuncios basados en sus visitas anteriores a nuestro sitio web u otros sitios web.',
      cookies: 'El uso de cookies publicitarias por parte de Google permite a Google y sus socios mostrarle anuncios basados en su visita a nuestros sitios y/u otros sitios en Internet.',
      optOut: 'Puede optar por no recibir publicidad personalizada visitando:'
    },
    cookies: {
      title: 'Cookies y Tecnologías de Seguimiento',
      content: 'Nuestro sitio web usa cookies para distinguirlo de otros usuarios de nuestro sitio web. Esto nos ayuda a brindarle una buena experiencia cuando navega por nuestro sitio web y también nos permite mejorar nuestro sitio. Los tipos de cookies que usamos incluyen:',
      item1: 'Cookies estrictamente necesarias: son necesarias para el funcionamiento de nuestro sitio web',
      item2: 'Cookies analíticas/de rendimiento: nos permiten reconocer y contar el número de visitantes y ver cómo se mueven los visitantes por nuestro sitio web',
      item3: 'Cookies de funcionalidad: se utilizan para reconocerlo cuando regresa a nuestro sitio web'
    },
    security: {
      title: 'Seguridad de Datos',
      content: 'Hemos implementado medidas de seguridad apropiadas para evitar que sus datos personales se pierdan accidentalmente, se usen o accedan de manera no autorizada, se alteren o divulguen. Limitamos el acceso a sus datos personales a aquellos empleados, agentes, contratistas y otros terceros que tengan una necesidad comercial de saberlo.'
    },
    thirdParty: {
      title: 'Enlaces de Terceros',
      content: 'Nuestro sitio web puede incluir enlaces a sitios web, complementos y aplicaciones de terceros. Hacer clic en esos enlaces o habilitar esas conexiones puede permitir que terceros recopilen o compartan datos sobre usted. No controlamos estos sitios web de terceros y no somos responsables de sus declaraciones de privacidad.'
    },
    children: {
      title: 'Privacidad de los Niños',
      content: 'Nuestros servicios están destinados a personas que tienen al menos 13 años. No recopilamos intencionalmente información personal de niños menores de 13 años. Si nos enteramos de que un niño menor de 13 años nos ha proporcionado información personal, tomaremos medidas para eliminar dicha información.'
    },
    rights: {
      title: 'Sus Derechos',
      content: 'Bajo ciertas circunstancias, usted tiene derechos bajo las leyes de protección de datos en relación con sus datos personales, incluido el derecho a:',
      item1: 'Solicitar acceso a sus datos personales',
      item2: 'Solicitar la corrección de sus datos personales',
      item3: 'Solicitar la eliminación de sus datos personales',
      item4: 'Objetar el procesamiento de sus datos personales'
    },
    changes: {
      title: 'Cambios a Esta Política de Privacidad',
      content: 'Podemos actualizar nuestra política de privacidad de vez en cuando. Le notificaremos cualquier cambio publicando la nueva política de privacidad en esta página y actualizando la fecha de "Última Actualización" en la parte superior de esta política de privacidad.'
    },
    contact: {
      title: 'Contáctenos',
      content: 'Si tiene alguna pregunta sobre esta política de privacidad o nuestras prácticas de privacidad, comuníquese con nosotros en:'
    }
  }
};
